import React from "react";
import "./topbar.css";
import imgLogoRadioPalamosWhite from "../../../assets/logos/imgLogoRadioPalamosWhite.png";
import LogoGiladev from "../../../assets/logos/imgLogoGiladev.png";

const MainTopbar = () => {

  return (
    <div id="main-topbar-wrapper">
      <a href="https://www.palamoscomunicacio.cat/" target="_blank" rel="noreferrer">
        <img
          src={imgLogoRadioPalamosWhite}
          className="main-topbar-logo-radiopalamos"
          alt="RÀDIO PALAMÓS"
        />
        <div className="main-topbar-logo-radiopalamos-text">ràdio palamós</div>
      </a>
      <div className="main-topbar-title">App Ràdio Palamós</div>
      <a href="https://www.giladev.com/" target="_blank" rel="noreferrer">
        <img
          src={LogoGiladev}
          className="main-topbar-logo-giladev"
          alt="Giladev"
        />
      </a>
    </div>
  );
};

export default MainTopbar;
